var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
function hex2rgb(hex) {
    const bigint = parseInt(hex.replace('#', ''), 16);
    return [bigint >> 16 & 255, bigint >> 8 & 255, bigint & 255];
}
export class GraphicIdentity extends Component {
    constructor() {
        super('GraphicIdentity', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            if ($('body').hasClass('home'))
                this.pickup();
            this.color = sessionStorage.getItem('graphic-identity-color');
            this.secondaryColor = sessionStorage.getItem('graphic-identity-color-secondary');
            this.logo = sessionStorage.getItem('graphic-identity-logo');
            if (!this.color || !this.secondaryColor || !this.logo)
                this.pickup();
            this.set(this.color, this.secondaryColor, this.logo);
            this.success();
        });
    }
    pickup() {
        const colors = JSON.parse(atob($('body').attr('data-colors')));
        const logos = JSON.parse(atob($('body').attr('data-logos')));
        // Random select a color which is not the current one
        let color = this.random(colors);
        while (color === this.color)
            color = this.random(colors);
        this.color = color;
        // Random select a secondary color which is not the current one
        this.secondaryColor = this.random(colors);
        while (this.secondaryColor === this.color)
            this.secondaryColor = this.random(colors);
        // Random select a logo which is not the current one
        let logo = this.random(logos);
        while (logo === this.logo)
            logo = this.random(logos);
        this.logo = logo;
        sessionStorage.setItem('graphic-identity-color', this.color);
        sessionStorage.setItem('graphic-identity-color-secondary', this.secondaryColor);
        sessionStorage.setItem('graphic-identity-logo', this.logo);
    }
    random(array) {
        return array[Math.floor(Math.random() * array.length)];
    }
    set(color, secondaryColor, logo) {
        if ($('.color-override').length > 0)
            color = $('.color-override').css('--color-main');
        const rgbColor = hex2rgb(color);
        const rgbSecondaryColor = hex2rgb(secondaryColor);
        $('body').css('--color-main', color);
        $('body').css('--color-main-rgb', rgbColor[0] + ', ' + rgbColor[1] + ', ' + rgbColor[2]);
        $('body').css('--color-secondary', secondaryColor);
        $('body').css('--color-secondary-rgb', rgbSecondaryColor[0] + ', ' + rgbSecondaryColor[1] + ', ' + rgbSecondaryColor[2]);
        $('.header-logo img').attr('src', logo);
        this.color = color;
        this.logo = logo;
    }
    getPrivacyPersonalizeStatus() {
        const privacySettings = JSON.parse(localStorage.getItem('hw-cookies-settings'));
        if (!privacySettings)
            return true;
        return privacySettings.personalize;
    }
}
